// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ClearFieldsButton-primaryButton-3dlirj","container":"ClearFieldsButton-container-6vj2U_","disabled":"ClearFieldsButton-disabled-2DtKqf"};